'use client'
import { useCallback, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import useIsWindowVisible from '@/hooks/useWindowVisible'
import { updateBlockNumber } from './actions'
import { useWalletData } from '@/utils'

export default function Updater(): null {
  const { findProvider: library, chainId } = useWalletData()
  const dispatch = useDispatch()

  const windowVisible = useIsWindowVisible()

  const [blockNumber, setBlockNumber] = useState<number | null>(null)

  // Function to fetch and update the block number immediately
  const fetchBlockNumber = useCallback(() => {
    if (!library) return
    library
      .getBlockNumber()
      .then((newBlockNumber: number) => {
        setBlockNumber((prev) => Math.max(prev || 0, newBlockNumber))
      })
      .catch((error) => {
        console.error(`Failed to fetch block number: ${error.message}`)
      })
  }, [library])

  // Callback for block events
  const onBlock = useCallback(
    (newBlockNumber: number) => {
      setBlockNumber((prev) => Math.max(prev || 0, newBlockNumber))
    },
    []
  )

  // Re-attach listeners when library or chainId changes
  useEffect(() => {
    if (!library || !windowVisible) return

    // Fetch the block number initially
    fetchBlockNumber()

    // Attach listeners
    library.on('block', onBlock)

    return () => {
      library.removeListener('block', onBlock)
    }
  }, [library, chainId, windowVisible, fetchBlockNumber, onBlock])

  // Dispatch block number to Redux
  useEffect(() => {
    if (blockNumber !== null && chainId && windowVisible) {
      dispatch(updateBlockNumber({ chainId, blockNumber }))
    }
  }, [blockNumber, chainId, dispatch, windowVisible])

  return null
}
// 'use client'
// import { useCallback, useEffect, useState } from 'react'
// import { useDispatch } from 'react-redux'
// import useDebounce from '@/hooks/useDebounce'
// import useIsWindowVisible from '@/hooks/useWindowVisible'
// import { updateBlockNumber } from './actions'
// import { useWalletData } from '@/utils'

// export default function Updater(): null {
//   const { findProvider: library, chainId, baseChain: currentChainId } = useWalletData()
//   const dispatch = useDispatch()
//   const windowVisible = useIsWindowVisible()

//   const [state, setState] = useState<{
//     chainId: number | undefined
//     blockNumber: number | null
//   }>({
//     chainId: currentChainId,
//     blockNumber: null
//   })

//   const blockNumberCallback = useCallback(
//     (blockNumber: number) => {
//       setState((state) => {
//         if (chainId === state.chainId) {
//           if (typeof state.blockNumber !== 'number') return { chainId, blockNumber }
//           return { chainId, blockNumber }
//         }
//         return state
//       })
//     },
//     [chainId]
//   )

//   // Network event handler
//   const handleNetworkChange = useCallback((newNetwork: { chainId: number }) => {
//     if (state.chainId && newNetwork.chainId !== state.chainId) {
//       setState(state => ({
//         ...state,
//         chainId: newNetwork.chainId,
//         blockNumber: null
//       }))
//     }
//   }, [state.chainId])

//   // Block number fetching
//   useEffect(() => {
//     if (!library || !windowVisible) return

//     let state = false

//     const fetchBlockNumber = async () => {
//       try {
//         const blockNumber = await library.getBlockNumber()
//         if (!state) {
//           blockNumberCallback(blockNumber)
//         }
//       } catch (error) {
//         console.error(`Failed to get block number for chainId: ${chainId}`, error)
//       }
//     }

//     fetchBlockNumber()

//     // Subscribe to new blocks
//     library.on('block', blockNumberCallback)
//     library.on('network', handleNetworkChange)

//     return () => {
//       state = true
//       library.removeListener('block', blockNumberCallback)
//       library.removeListener('network', handleNetworkChange)
//     }
//   }, [library, windowVisible, chainId, blockNumberCallback, handleNetworkChange])

//   // Update chain ID effect
//   useEffect(() => {
//     setState(state => ({
//       ...state,
//       chainId: currentChainId
//     }))
//   }, [currentChainId])

//   const debouncedState = useDebounce(state, 100)

//   // Dispatch block number updates
//   useEffect(() => {
//     if (!debouncedState.chainId || !debouncedState.blockNumber || !windowVisible) return
//     dispatch(
//       updateBlockNumber({
//         chainId,
//         blockNumber: debouncedState.blockNumber
//       })
//     )
//   }, [
//     windowVisible,
//     dispatch,
//     debouncedState.blockNumber,
//     debouncedState.chainId,
//     chainId
//   ])

//   return null
// }
